import { AppQueues, FetchMethod, QueuePoolState } from "./types";
import { QueuePool } from "./queuePool";

export const queueNames: Record<AppQueues, AppQueues> = Object.freeze({
  invoice: "invoice",
  transactionCash: "transactionCash",
  transactionPos: "transactionPos",
});

export function initAppQueuePool(
  queuePool: ReturnType<typeof QueuePool>,
  userId: number,
  fetchQueuePool: QueuePoolState,
  fetchMethods: Record<AppQueues, FetchMethod>
): void {
  queuePool
    .initPool(userId, fetchQueuePool)
    .addQueue(queueNames.invoice, fetchMethods.invoice)
    .addQueue(queueNames.transactionPos, fetchMethods.transactionPos)
    .addQueue(queueNames.transactionCash, fetchMethods.transactionCash);
}
